/* 🤖 this file was generated by svg-to-ts */
export const iconShop16: {
  name: 'shop_16';
  data: string;
} = {
  name: 'shop_16',
  data: `<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M14 13c0 .552-.449 1-1 1h-2v-2.333c0-1.654-1.346-3-3-3s-3 1.346-3 3V14H3c-.551 0-1-.448-1-1V7c1.2 0 2.266-.542 3-1.382C5.734 6.458 6.8 7 8 7s2.266-.542 3-1.382C11.734 6.458 12.8 7 14 7v6Zm-5 1H7v-2.333a1.001 1.001 0 0 1 2 0V14ZM2 3c0-.552.449-1 1-1h1v1c0 1.103-.897 2-2 2V3Zm4-1h4v1c0 1.103-.897 2-2 2s-2-.897-2-2V2Zm8 1v2c-1.103 0-2-.897-2-2V2h1c.551 0 1 .448 1 1Zm-1-3H3C1.346 0 0 1.346 0 3v10c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3V3c0-1.654-1.346-3-3-3Z"/></svg>`,
};
